module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "team"
  }, [_c('h1', [_vm._v("Meet the Team")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n\t\t\tIf you are looking for reliable and expert web development services then you are in the right place.\n\t\t\tOur expert team of web developers are ready to work together.\n\t\t\t")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('small', [_vm._v("Want to join our team? Visit our "), _c('router-link', {
    attrs: {
      "to": "careers"
    }
  }, [_vm._v("careers page")]), _vm._v(" for more details!")], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "media-list team-list"
  }, [_c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": "static/images/team/chen.jpg",
      "alt": "Web Development and Consulting"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Chen Koifman")]), _vm._v("\n\t\t\t\t\tFounder & Leader Web Developer\n\t\t\t\t\t"), _c('p', [_c('small', [_vm._v("\n\t\t\t\t\t\t\tOver 15 years of experience as a leader web developer/JS expert."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tIn his resume some of the world's most influential organizations (SAP, Nice, AVG, Cellebrite) and Israeli leading companies (Migdal, Wallashops, Sela, Code Oasis)."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tMy expertise is focused on web development using: Angular, Redux, Node.js, Express, Vue.js, Webpack, ES6 and more...\n\t\t\t\t\t\t")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57b9b8e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/team.vue
// module id = 53
// module chunks = 1